import { ErrorPage_Default } from "@ubnt/ui-components/aria/ErrorPage";
import { app } from "../config/config";

export const ErrorPage: React.FC = () => {
  return (
    <ErrorPage_Default
      title="Page not Found"
      actionButtonText="Go to Account Portal"
      description="Please ensure that you have entered the correct URL. If you have bookmarked this page but still cannot access it, the address may have recently changed."
      actionButtonProps={{
        onClick: () => (window.location.href = app.accountUrl),
      }}
    />
  );
};
